import {postRequest} from '../libs/AxiosService.util';

export async function serviceCreateState(params) {
    return await postRequest('states/create', params);
}

export async function serviceUpdateState(params) {
    return await postRequest('states/update', params);
}

export async function serviceDeleteState(params) {
    return await postRequest('states/delete', params);
}

export async function serviceGetState (params) {
    return await postRequest('states', params);
}

export async function serviceGetStateList (params) {
    return await postRequest('units/list', params);
}

export async function serviceUnitCheck (params) {
    return await postRequest('units/check', params);
}
export async function serviceGetStateDetails (params) {
    
    return await postRequest('states/detail', params);
}

